import { RAGStatus } from '../../../../../../../shared/entities/RAGStatus';
import { useGetOneResponseProject } from '../../../hooks/useGetOneResponseProject.hooks';

type ResponseProjectGenerationStatus = 'pending' | 'finished';

export function useResponseProjectGenerationStatus(
  projectId: number,
): ResponseProjectGenerationStatus {
  const { data: project } = useGetOneResponseProject(projectId);

  if (
    project.blockGenerationStatus === RAGStatus.DONE ||
    project.blockGenerationStatus === RAGStatus.FAILED ||
    project.blockGenerationStatus === RAGStatus.NO_SUPPORTED_DOCUMENTS
  ) {
    return 'finished';
  }

  return 'pending';
}
